module.exports = __webpack_public_path__ + "img/pie-chart-fill.3fac46a2.svg";